import React, {useEffect, useState} from "react"
import {useStateValue} from "../../states/StateProvider"
import {GrClose} from "react-icons/gr"
import PropTypes from "prop-types"
import Api from "../../Api/api"
import {ScaleLoader} from "react-spinners"

const CompanyInfoPopUp = ({company, Info, portal}) => {
    const [{companyInfoModal}, dispatch] = useStateValue()
    const [email, setEmail] = useState('')

    const line1 = Info?.Zeile1?.replaceAll(/Firma:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line2 = Info?.Zeile2?.replaceAll(/Anschrift:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line3 = Info?.Zeile3?.replaceAll(/Kurz:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line4 = Info?.Zeile4?.replaceAll(/US-Id:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line5 = Info?.Zeile5?.replaceAll(/Tel. Zentrale:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const Web = Info?.Zeile6?.replace('Web:', '').trim()
    const line8 = Info?.Zeile8
    const line9 = Info?.Zeile9?.replace(' | ', ', ').replaceAll(/FKB:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line11 = Info?.Zeile11
    const line12 = Info?.Zeile12 !== 'KVD:  | ' && Info?.Zeile12 !== null  ? Info?.Zeile12?.replace(' | ', ', ').replaceAll(/KVD:/gi, match => `<span style="color: #a1a1a1">${match} </span>`) : ''
    const line13 = Info?.Zeile13 !== 'KFD:  | ' && Info?.Zeile13 !== null ? Info?.Zeile13?.replace(' | ', ', ').replaceAll(/KFD:/gi, match => `<span style="color: #a1a1a1">${match} </span>`) : ''
    const line14 = Info?.Zeile14 !== 'KBD:  | ' && Info?.Zeile14 !== null ? Info?.Zeile14?.replace(' | ', ', ').replaceAll(/KBD:/gi, match => `<span style="color: #a1a1a1">${match} </span>`): ''
    const line16 = Info?.Zeile16
    const line17 = Info?.Zeile17?.replaceAll(/Name:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line18 = Info?.Zeile18?.replaceAll(/Tel. Direkt:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line19 = Info?.Zeile19?.replaceAll(/Mobil:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line20 = Info?.Zeile20?.replaceAll(/Privat:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)
    const line21 = Info?.Zeile21?.replaceAll(/E-Mail:/gi, match => `<span style="color: #a1a1a1">${match} </span>`)

    useEffect(() => {
        dispatch({type: 'SET_SENDMAIL', item: false})
    }, [])

    useEffect(() => {
        if (Info?.Zeile21) {
            const mail = extractEmails(Info?.Zeile21)
            setEmail(mail?.[0] || 'N/A')
        }
    }, [Info])

    function extractEmails(text) {
        return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi)
    }

    return (<div className='px-5 pb-3 rounded-lg'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            {/* Firma Column */}
            <div className="space-y-1">
                <p style={{color: '#000000'}} className='font-bold'>Firma</p>
                <div dangerouslySetInnerHTML={{__html: line1}}/>
                <div dangerouslySetInnerHTML={{__html: line2}}/>
                <div dangerouslySetInnerHTML={{__html: line3}}/>
                <div dangerouslySetInnerHTML={{__html: line4}}/>
                <div dangerouslySetInnerHTML={{__html: line5}}/>
                <div className='flex'>
                    <p style={{color: '#a1a1a1'}} className='mr-1'>Web:</p>
                    <a href={Web.startsWith('http') ? Web : `https://${Web}`}
                       target="_blank"
                       rel="noopener noreferrer"
                       style={{color: '#3A46A9'}}
                       className='underline cursor-pointer'>{Web}</a>
                </div>
            </div>

            {/* Ansprechpartner Column */}
            <div className="space-y-1">
                <p style={{color: '#000000'}} className='font-bold'>{line16}</p>
                <div dangerouslySetInnerHTML={{__html: line17}}/>
                <div dangerouslySetInnerHTML={{__html: line18}}/>
                <div dangerouslySetInnerHTML={{__html: line19}}/>
                <div dangerouslySetInnerHTML={{__html: line20}}/>
                <div dangerouslySetInnerHTML={{__html: line21}}/>
            </div>

            {/* Bank & R+V-Struktur Column */}
            <div className="space-y-1">
                <p style={{color: '#000000'}} className='font-bold'>{line8}</p>
                <div dangerouslySetInnerHTML={{__html: line9}}/>
                {line12 && line13 && line14 && <div className="font-bold" dangerouslySetInnerHTML={{__html: line11}}/>}
                <div dangerouslySetInnerHTML={{__html: line12}}/>
                <div dangerouslySetInnerHTML={{__html: line13}}/>
                <div dangerouslySetInnerHTML={{__html: line14}}/>
            </div>
        </div>
    </div>)
}

export default CompanyInfoPopUp

CompanyInfoPopUp.propTypes = {
    company: PropTypes.string.isRequired, portal: PropTypes.string.isRequired, Info: PropTypes.object, // optional if preloaded
}
